import { render, staticRenderFns } from "./RestoreUser.vue?vue&type=template&id=352215dc&scoped=true"
import script from "./RestoreUser.vue?vue&type=script&lang=js"
export * from "./RestoreUser.vue?vue&type=script&lang=js"
import style0 from "./RestoreUser.vue?vue&type=style&index=0&id=352215dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352215dc",
  null
  
)

export default component.exports